import { render } from "./monitorDetail.vue?vue&type=template&id=38059216&scoped=true"
import script from "./monitorDetail.vue?vue&type=script&lang=js"
export * from "./monitorDetail.vue?vue&type=script&lang=js"

import "./monitorDetail.vue?vue&type=style&index=0&id=38059216&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38059216"]])

export default __exports__